import React, { useMemo } from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";

const StockHolderTargetViewTable = ({
    beatTargetList,
}) => {

    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue)
    };

    const filteredTableData = useMemo(() => {
        return beatTargetList.filter((currentRow) => {
            const beatName = currentRow.beatName ?? "-";
            return beatName
                .toLowerCase()
                .includes(searchValue.toLowerCase());
        });
    }, [beatTargetList, searchValue]);

    return (
        <>
            {beatTargetList.length !== 0 && (
                <>
                    <LandingScreenHeader
                        screenTitle={""}
                        showSearchBox={true}
                        showTable={true}
                        showFilter={false}
                        showPdfDownload={false}
                        showExcelDownload={false}
                        onSearch={onSearchValue}
                    />

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "550px",
                            position: "relative",
                        }}
                    >
                        <table
                            style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#03a9f4",
                                    zIndex: 3,
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <tr>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "70px" }}>Sr.No</th>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "150px" }}>Region Name</th>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px" }}>State Name</th>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "150px" }}>Zone Name</th>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "180px" }}>Area Name</th>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "180px" }}>Beat Name</th>
                                    {beatTargetList[0].months.map((monthObj) => (
                                        <th
                                            key={monthObj}
                                            style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px" }}
                                        >
                                            {monthObj.entityName || ""}
                                        </th>
                                    ))}

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "150px" }}>Total Target</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredTableData.map((team, index) => (
                                    <tr key={team.id}>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "center",
                                            width: "490px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.index !== null ? team.index : ""}
                                        </td>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            width: "490px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.regionName !== null ? team.regionName : ""}
                                        </td>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            width: "490px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.stateName !== null ? team.stateName : ""}
                                        </td>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            width: "490px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.zoneName !== null ? team.zoneName : ""}
                                        </td>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            width: "510px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.areaName !== null ? team.areaName : ""}
                                        </td>
                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            width: "510px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.beatName !== null ? team.beatName : ""}
                                        </td>
                                        {team.months.map((monthObj, idx) => (
                                            <td
                                                key={idx}
                                                style={{
                                                    ...claimManagementStyles.cellStyle,
                                                    minWidth: "120px",
                                                    textAlign: "right",
                                                    maxHeight: "28px",
                                                    lineHeight: "28px",
                                                }}
                                            >
                                                {monthObj.intValue !== null ? ConvertAmount({ amount: monthObj.intValue }) : 0}
                                            </td>
                                        ))}

                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "right",
                                            width: "490px",
                                            maxHeight: "28px",
                                            lineHeight: "28px",
                                        }}>
                                            {team.totalTarget !== null ? ConvertAmount({ amount: team.totalTarget }) : ""}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StockHolderTargetViewTable);
